import {
  SET_USER,
  CLEAR_USER,
} from '../constants/actionTypes';

const loggedUser = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))

const initialState = loggedUser || null;

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    case CLEAR_USER:
      return initialState;
    default:
      return state;
  }
}

export default user;



// WEBPACK FOOTER //
// ./src/reducers/reducer-user.js